/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {confirmPasscode} from '../api'

export const useMutationConfirmPasscode = createReactQueryMutationHook('confirmPasscode', confirmPasscode)
